/**
 * The HTML tag names components are built from, uppercase the way `Element.tagName` reports them.
 * `satisfies` keeps each constant a literal type while still checking it against the DOM's own list,
 * so a typo fails to compile.
 */
export type HtmlTagName = Uppercase<keyof HTMLElementTagNameMap>;

export const A = "A" satisfies HtmlTagName;
export const AUDIO = "AUDIO" satisfies HtmlTagName;
export const BUTTON = "BUTTON" satisfies HtmlTagName;
export const DIV = "DIV" satisfies HtmlTagName;
export const FIGURE = "FIGURE" satisfies HtmlTagName;
export const FORM = "FORM" satisfies HtmlTagName;
export const H1 = "H1" satisfies HtmlTagName;
export const H2 = "H2" satisfies HtmlTagName;
export const HEADER = "HEADER" satisfies HtmlTagName;
export const HR = "HR" satisfies HtmlTagName;
export const I = "I" satisfies HtmlTagName;
export const IMG = "IMG" satisfies HtmlTagName;
export const INPUT = "INPUT" satisfies HtmlTagName;
export const LABEL = "LABEL" satisfies HtmlTagName;
export const LI = "LI" satisfies HtmlTagName;
export const NAV = "NAV" satisfies HtmlTagName;
export const P = "P" satisfies HtmlTagName;
export const SECTION = "SECTION" satisfies HtmlTagName;
export const SELECT = "SELECT" satisfies HtmlTagName;
export const SPAN = "SPAN" satisfies HtmlTagName;
export const TABLE = "TABLE" satisfies HtmlTagName;
export const TBODY = "TBODY" satisfies HtmlTagName;
export const TD = "TD" satisfies HtmlTagName;
export const TEXTAREA = "TEXTAREA" satisfies HtmlTagName;
export const TH = "TH" satisfies HtmlTagName;
export const THEAD = "THEAD" satisfies HtmlTagName;
export const TR = "TR" satisfies HtmlTagName;
export const UL = "UL" satisfies HtmlTagName;
